// Import of actions
import * as PatientActions from "../actions/patient.actions";
import { IDiaprofilPatient } from "../../models/diaprofil-patient";

export type PatientState = IDiaprofilPatient[];

export const initialState: PatientState = [];

export function patientReducer(
  state = initialState,
  action: PatientActions.Actions
): PatientState {
  switch (action.type) {
    case PatientActions.RESET_STATE: {
      return initialState;
    }

    case PatientActions.ADD: {
      return state.find(patient => patient.fhirId === action.payload.fhirId)
        ? state
        : [...state, action.payload];
    }

    case PatientActions.REPLACE: {
      return [
        ...state.filter(patient => patient.fhirId !== action.payload.fhirId),
        action.payload // payload is FHIR resource
      ];
    }

    case PatientActions.REPLACE_MULTIPLE: {
      const replacedIds = action.payload.map(elem => elem.fhirId)
      return [
        ...state.filter(
          item => !replacedIds.includes(item.fhirId)
        ),
        ...action.payload // payload is FHIR resource
      ];
    }

    case PatientActions.UPDATE: {
      return state.map(patient => {
        return patient.fhirId === action.payload.fhirId
          ? { ...patient, ...action.payload }
          : patient;
      });
    }

    case PatientActions.DELETE: {
      return state.filter(patient => patient.fhirId !== action.payload.fhirId);
    }

    // We do not have a reducer for the LOAD action as it doesn't alter the state
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/patient.reducer.ts